import React, {Component} from 'react';
import { config } from "../libs/utils/Const";
import $ from 'jquery';
import {ApiClient} from "../libs/apiClient/ApiClient";
let apiClient = ApiClient.getInstance();

class CrearPaqueteModal extends Component {


    CloseConfirm = ()=>{
        $('#exampleModalConfirm').modal('hide');
    }

    
    
    render (){
        const {createNewPackage} = this.props;
        return (
        <div> 
            {/*--------------- MODAL CONFIRMA ---------------*/}
            <div class="modal fade exampleModalConfirm" id="exampleModalConfirm" tabindex="-1" role="dialog" aria-labelledby="exampleModalConfirmLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalConfirmLabel">Creación de paquete</h5>
                            <button type="button" class="close" onClick={this.CloseConfirm} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div className = "col-md-12">
                                    <h6>Seleccione un tipo de paquete</h6>
                                    <div className = "row justify-content-center mx-auto text-center">
                                        <button
                                            className="btn btn-sm"
                                            type="button"
                                            style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                            onClick={() => createNewPackage(1)}>
                                            Automático
                                        </button>
                                        <button
                                            className="btn btn-sm ml-5"
                                            type="button"
                                            style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                            onClick={() => createNewPackage(2)}>
                                            Selección
                                        </button>
                                    </div>
                                </div>
                                
                            </form>
                        </div>
                        <div class="modal-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default CrearPaqueteModal